import React from 'react';
import ContactCreate from './ContactCreate';

const ContactDetail = () => {
  return (
    <div>
      <ContactCreate />
    </div>
  );
};

export default ContactDetail;
